/* Hona 2026-10-05: legally required recurring price disclosure inside the Recharge subscription box */
(function () {
  var NOTE_CLASS = 'hona-recurring-price';
  function inject(root) {
    var sub = root.querySelector('.rc-purchase-option__subscription');
    if (!sub) return;
    var priceEl = sub.querySelector('[part~="rc-purchase-option__discounted-price"]') || sub.querySelector('.rc-purchase-option__prices .rc-price:last-child');
    if (!priceEl) return;
    var m = priceEl.textContent.replace('Discounted price:', '').match(/[$€£]\s?[\d,]+(?:\.\d{2})?/);
    if (!m) return;
    var text = 'Recurring price: ' + m[0].replace(/\s/g, '') + ' billed every month until you cancel. Cancel anytime.';
    var note = sub.querySelector('.' + NOTE_CLASS);
    if (note) { if (note.textContent !== text) note.textContent = text; return; }
    var container = sub.querySelector('.rc-purchase-option__sub-container') || sub;
    note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.setAttribute('style', 'margin-top:8px;font-size:11px;font-weight:400;line-height:1.4;color:#0f3e36;');
    note.textContent = text;
    container.appendChild(note);
  }
  function attach(widget) {
    if (widget.__honaRecurring || !widget.shadowRoot) return;
    widget.__honaRecurring = true;
    var root = widget.shadowRoot, busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      requestAnimationFrame(function () { busy = false; inject(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
    inject(root);
  }
  function scan() { document.querySelectorAll('recharge-subscription-widget').forEach(attach); }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
